// extracted by mini-css-extract-plugin
export default {"mobile_slider":"style_mobile_slider__h9cpk","main_padding":"style_main_padding__lg36F"};